import ReviewsSectionBase from "@/components/sections/products/shared/reviews-base";
import { STATS_CUSTOMERS_DE } from "./stats-de";

interface Props {
  excludeProduct?: "mobile" | "residential";
}

// German clone of src/components/sections/shared/reviews — reuses the exact
// same underlying ReviewsSectionBase (real review data, logos), only the
// heading/body text is translated.
export default function ReviewsDe({ excludeProduct }: Props) {
  return (
    <ReviewsSectionBase
      headingId="reviews-heading"
      eyebrow="Kundenbewertungen"
      heading={`${STATS_CUSTOMERS_DE} von Teams vertrauen uns.`}
      body="Echtes Feedback von Entwicklern, Growth-Teams und Agenturen, die täglich auf Proxidize setzen."
      excludeProduct={excludeProduct}
    />
  );
}
